import $http from '../connectionProxy'

export const authenticate = ({ email, password }) => $http.post('/responsibles_area/auth/sign_in', { email, password })

export const newPassword = (invitationToken, password) => $http.patch('/responsibles_area/auth/invitation', { accept_invitation: { invitation_token: invitationToken, password } })

export const recoverAccount = email => $http.post('/responsibles_area/auth/password', { email: email })

export const resetPassword = payload => $http.patch('/responsibles_area/auth/password', payload)
